<template>
  <v-container fluid>
    <!-- <template>
      <div style="background-color: rgb(118 126 137);">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
      </div>
    </template> -->

    <v-row class="mt-2">
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-flag </v-icon>
            Terminal Configuration
            <v-spacer />
          </v-card-title>

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <div class="mt-5">
                <label
                  ><B>Event Name : </B>
                  {{
                    selectedEvent.EventName ? selectedEvent.EventName : "N/A"
                  }}</label
                >
              </div>

              <div class="mt-5">
                <label
                  ><B>StallHolder Name : </B>
                  {{ selectStallHolder ? selectStallHolder : "N/A" }}</label
                >
              </div>

              <div class="mt-5">
                <label
                  ><B>Stall Name : </B>
                  {{ selectStall ? selectStall.StallName : "N/A" }}</label
                >
              </div>

              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.TerminalNumber"
                    label="TerminalNumber"
                    :rules="terminalNumberRules"
                    type="number"
                    min="0"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row v-show="this.setNewObj">
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.terminalsToAdd"
                    label="Total terminals to add"
                  ></v-text-field>
                  <p>
                    Note: If you select 123 as the terminal number and request 5
                    terminals, terminals 123-127 will be created
                  </p>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.OrderPrefix"
                    label="Order Prefix"
                    required
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="5"
                  offset-md="1"
                  style="margin-top: 45px; font-size: 18px"
                >
                  <span>Use stall settings</span>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <label>Payment Profile</label>
                  <v-row class="ml-1">
                    <v-checkbox
                      v-model="isCashSelected"
                      label="Cash"
                      class="mr-5"
                      :disabled="isSelectPaymentProfile"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="isCardSelected"
                      label="Card"
                      class="mr-5"
                      :disabled="isSelectPaymentProfile"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="isVoucherSelected"
                      label="Voucher"
                      :disabled="isSelectPaymentProfile"
                    ></v-checkbox>
                  </v-row>
                </v-col>

                <v-col cols="5" offset-md="1">
                  <v-checkbox
                    v-model="isSelectPaymentProfile"
                    :label="eventSettings.PaymentProfile"
                    class="mr-5"
                    style="padding-top: 12px"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <label>Printing Profile</label>
              <v-row class="ml-1">
                <v-col cols="6">
                  <v-row>
                    <div v-for="item in PrintingList" :key="item.id">
                      <v-checkbox
                        v-model="editedItem.PrintingProfile"
                        :label="item.name"
                        :value="item.name"
                        class="mr-5"
                        :rules="eventPrintRules"
                        required
                        :disabled="isSelectPrintingProfile"
                      ></v-checkbox>
                    </div>
                  </v-row>
                </v-col>

                <v-col cols="5" offset-md="1">
                  <v-checkbox
                    v-model="isSelectPrintingProfile"
                    :label="eventSettings.PrintingProfile"
                    class="mr-5"
                    style="margin-top: 4px; margin-left: -8px"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-combobox
                    v-model="eventSettings.InUse"
                    :items="InUseTypes"
                    item-text="name"
                    label="Terminal In Use"
                    :return-object="false"
                    required
                  ></v-combobox>
                </v-col>
              </v-row>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="handleClickCancel()">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" @click="submitForm">
                  Submit
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // you have access to iziToast now
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    terminalData: {
      type: Object,
      default: null,
    },
    stallData: {
      type: Object,
      default: null,
    },
    stallholderData: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    breadcrumbs: [
      {
        text: "Stall",
        disabled: false,
        href: "/StallholdersStallsStaffTerminals",
      },
      {
        text: "Terminal Configuration",
        disabled: true,
        href: "",
      },
    ],
    Action: "",
    editedItem: {
      EventId: "",
      StallholderId: "",
      StallId: "",
      TerminalNumber: "",
      PaymentProfile: [],
      PrintingProfile: "",
      // OrderNumbers: 'No',
      OrderPrefix: "",
      terminalsToAdd: 1,
      InUse: "",
      PaymentProfileInherit: true,
      PrintingProfileInherit: true,
    },
    PrintingList: [
      {
        id: 1,
        name: "Print",
      },
      {
        id: 2,
        name: "Prompt",
      },
      {
        id: 3,
        name: "Bypass",
      },
    ],
    // OrderNumberTypes: [
    //     { id: true, name: 'Yes'},
    //     { id: false, name: 'No'}
    // ],
    InUseTypes: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    stallHolders: [],
    stallHoldersList: [],
    selectStallHolder: "",
    selectStall: "",

    stalls: [],

    terminalNumberRules: [(v) => !!v || "Terminal Number is required"],
    eventPrintRules: [(v) => !!v || "Printing Profile is required"],

    eventSettings: {
      PaymentProfile: "",
      PrintingProfile: "",
      InUse: "No",
      OrderNumbers: "",
    },

    terminalsToAdd: 1,

    isSelectPaymentProfile: false,
    isSelectPrintingProfile: false,
  }),

  updated: function () {},

  computed: {
    ...mapState("filter", [
      "globalEventFilter",
      // 'allEvents',
      "allStallHolders",
    ]),

    setNewObj() {
      return this.isNew;
    },

    selectedEvent: {
      get() {
        return this.globalEventFilter;
      },
      set(value) {
        console.log("EVENT IS CHANGED MAKE API REQUEST 111", value);
      },
    },

    // events() {
    //   return this.allEvents.map((obj) => {
    //     return {text: obj.EventName, value: obj.EventId}
    //   });
    // }

    isCashSelected: {
      get() {
        return (this.editedItem.PaymentProfile || []).includes("Cash");
      },
      set(value) {
        this.updatePaymentProfile("Cash", value);
      },
    },
    isCardSelected: {
      get() {
        return (this.editedItem.PaymentProfile || []).includes("Card");
      },
      set(value) {
        this.updatePaymentProfile("Card", value);
      },
    },
    isVoucherSelected: {
      get() {
        return (this.editedItem.PaymentProfile || []).includes("Voucher");
      },
      set(value) {
        this.updatePaymentProfile("Voucher", value);
      },
    },
  },
  watch: {
    setNewObj(value) {
      value;
    },

    selectedEvent(val) {
      this.handleChangeEvent(val);
    },
    isSelectPaymentProfile(val) {
      // Generated when payment profile inherit box is checked.
      if (val !== null && val === true) {
        if (this.stallData) {
          // Handle both string and array formats
          if (Array.isArray(this.stallData.PaymentProfile)) {
            this.editedItem.PaymentProfile = [...this.stallData.PaymentProfile];
          } else if (typeof this.stallData.PaymentProfile === "string") {
            var str = this.stallData.PaymentProfile;
            str = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
              return letter.toUpperCase();
            });
            this.editedItem.PaymentProfile = str.split(", ");
          } else {
            this.editedItem.PaymentProfile = [];
          }
          this.editedItem.PaymentProfileInherit = val;
        }
      } else {
        this.editedItem.PaymentProfile = [];
        this.editedItem.PaymentProfileInherit = false;
      }
    },

    isSelectPrintingProfile(val) {
      // Generated when printing profile inherit box is checked.
      if (val !== null && val === true) {
        if (this.stallData) {
          this.editedItem.PrintingProfile =
            this.stallData.PrintingProfile || "";
          this.eventSettings.PrintingProfile =
            this.stallData.PrintingProfile || "";
          this.editedItem.PrintingProfileInherit = val;
        }
      } else {
        this.editedItem.PrintingProfile = this.stallData
          ? this.stallData.PrintingProfile || ""
          : "";
        this.editedItem.PrintingProfileInherit = false;
      }
    },
  },
  created() {
    // Triggers when a terminal is created or edited
    console.log("starting created()", this.setNewObj);

    if (this.id && this.id !== "0") {
      if (this.terminalData) {
        // Use props data when available
        console.log("Editing terminal - Terminal data:", this.terminalData);
        this.Action = "update";
        this.editedItem = { ...this.terminalData };

        // Set inherit flags to true by default for update action
        this.editedItem.PaymentProfileInherit =
          this.terminalData.PaymentProfileInherit !== undefined
            ? this.terminalData.PaymentProfileInherit
            : true;
        this.editedItem.PrintingProfileInherit =
          this.terminalData.PrintingProfileInherit !== undefined
            ? this.terminalData.PrintingProfileInherit
            : true;

        // Set the checkbox states based on inherit flags
        this.isSelectPaymentProfile = this.editedItem.PaymentProfileInherit;
        this.isSelectPrintingProfile = this.editedItem.PrintingProfileInherit;

        // Set stall and stallholder data from props
        if (this.stallData) {
          this.selectStall = this.stallData;
          this.editedItem.StallId = this.stallData.StallId;
        }
        if (this.stallholderData) {
          this.selectStallHolder = this.stallholderData.StallholderName;
        }
      } else {
        console.warn("Terminal data not provided via props for edit mode");
        this.Action = "update";
      }
    } else {
      this.Action = "create";
      // Set stall and stallholder data for new terminals
      if (this.stallData) {
        this.selectStall = this.stallData;
        this.editedItem.StallId = this.stallData.StallId;
      }
      if (this.stallholderData) {
        this.selectStallHolder = this.stallholderData.StallholderName;
      }

      // Set inherit flags to true by default for new terminals
      this.editedItem.PaymentProfileInherit = true;
      this.editedItem.PrintingProfileInherit = true;
      this.isSelectPaymentProfile = true;
      this.isSelectPrintingProfile = true;
    }
    this.handleStallHolder();
  },

  mounted() {
    // Disable event selector while on this page
    this.setEventSelectorDisabled(true);
  },

  beforeDestroy() {
    // Re-enable event selector when leaving this page
    this.setEventSelectorDisabled(false);

    // Clean up any old localStorage data that might still exist
    localStorage.removeItem("setTerminalObj");
    localStorage.removeItem("setStallselectObj");
    localStorage.removeItem("setStallHolderselectObj");
    localStorage.removeItem("setNewObj");
  },
  methods: {
    ...mapActions("admin", ["createEvent", "getEventMetadata"]),
    ...mapActions("filter", ["initialLogin"]),
    ...mapMutations("admin", [
      "setEventSelectorDisabled",
      "setCurrentEventManagementTab",
    ]),

    handleStallHolder: function () {
      if (this.selectedEvent.EventName !== undefined) {
        this.handleChangeEvent(this.selectedEvent);
      }
    },

    haddleIsSelecters: function () {
      this.isSelectPaymentProfile = false;
      this.isSelectPrintingProfile = false;
    },

    // handleChangeEvent: function(obj) {
    handleChangeEvent: function () {
      // Triggers when a new terminal is created or a terminal is edited.
      console.log("Starting handleChangeEvent: ", this.editedItem);

      this.stallHolders = [];
      this.editedItem.StallholderId = "";

      // Use props data instead of localStorage
      if (this.stallData) {
        this.selectStall = this.stallData;
        this.editedItem.StallId = this.stallData.StallId;

        // Set event settings from stall data for display
        this.eventSettings.PaymentProfile = Array.isArray(
          this.stallData.PaymentProfile
        )
          ? this.stallData.PaymentProfile.join(", ")
          : this.stallData.PaymentProfile || "";
        this.eventSettings.PrintingProfile =
          this.stallData.PrintingProfile || "";
      }

      // Set default values
      this.editedItem.terminalsToAdd = this.editedItem.terminalsToAdd || 1;
      this.editedItem.OrderPrefix = this.editedItem.OrderPrefix || "";

      // Map stallholders for dropdown
      if (this.globalEventFilter && this.globalEventFilter.Stallholders) {
        this.stallHolders = this.globalEventFilter.Stallholders.map((obj) => {
          return { text: obj.StallholderName, value: obj.StallholderId };
        });
      }
    },

    haddleChangeStall: function (obj) {
      this.eventSettings.PaymentProfile =
        obj.PaymentProfile !== undefined ? obj.PaymentProfile.join(", ") : "";
      this.eventSettings.PrintingProfile = obj.PrintingProfile;
      // this.eventSettings.OrderNumbers = obj.OrderNumbers
    },
    submitForm: function () {
      console.log("Starting SubmitForm", this.editedItem);

      // Use stallholder data from props instead of localStorage
      if (this.stallholderData) {
        this.editedItem.StallholderId = this.stallholderData.StallholderId;
        console.log("SubmitForm stallholderData", this.stallholderData);
        console.log(
          "SubmitForm this.editedItem.StallholderId",
          this.editedItem.StallholderId
        );
      } else {
        console.error("No stallholder data available for submission");
        return;
      }

      try {
        if (this.$refs.form.validate()) {
          this.editedItem.EventId = this.selectedEvent.EventId;
          this.editedItem.InUse =
            this.eventSettings.InUse === "Yes" ? true : false;

          let event_item = [
            {
              Type: "Terminal",
              Action: this.Action,
              Properties: this.editedItem,
            },
          ];

          let submitEvent = {
            event_items: event_item,
          };

          console.log("submitEvent");
          console.log(submitEvent);
          this.createEvent(submitEvent)
            .then((response) => {
              this.redirectReload();

              iziToast.success({
                title: "Terminal",
                message: "Updating record!",
                position: "topRight",
              });
              console.log("response");
              console.log(response);
            })
            .catch((err) => {
              console.log("err");
              console.log(err);
              iziToast.warning({
                title: "Terminal",
                message: "Fail to inserted record!",
                position: "topRight",
              });
            });
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleClickCancel: function () {
      // Navigate back to Terminals tab specifically
      this.setCurrentEventManagementTab("Terminals");
      this.$router.push({ name: "EventManagement" });
    },
    async redirectReload() {
      try {
        // Refresh the event data without resetting all state
        if (this.selectedEvent?.EventId) {
          await this.getEventMetadata(this.selectedEvent.EventId);
        }

        // Navigate back to Terminals tab specifically
        this.setCurrentEventManagementTab("Terminals");
        this.$router.push({ name: "EventManagement" });
      } catch (error) {
        console.error("Error refreshing data:", error);
        // Fallback to navigation without refresh
        this.setCurrentEventManagementTab("Terminals");
        this.$router.push({ name: "EventManagement" });
      }
    },
    updatePaymentProfile(value, checked) {
      let currentProfile = [...(this.editedItem.PaymentProfile || [])];
      if (checked) {
        if (!currentProfile.includes(value)) {
          currentProfile.push(value);
        }
      } else {
        currentProfile = currentProfile.filter((item) => item !== value);
      }
      this.editedItem.PaymentProfile = currentProfile;
    },
  },
};
</script>
